import { createSelector } from 'reselect';
import { path, prop, pipe } from 'ramda';
import moment from 'moment';

import { CURRENT } from 'constants/observationStatuses';
import { getResearchersAndDoctors } from '../patientsData';

const localState = prop('tachyReport');

export const getData = createSelector(
  localState,
  prop('data'),
);

export const getDocumentId = createSelector(
  getData,
  path(['entry', '0', 'resource', 'id']),
);

export const getLoading = createSelector(
  localState,
  prop('loading'),
);

export const isEntry = createSelector(
  getData,
  pipe(
    prop('entry'),
    Boolean,
  ),
);

export const getTachyReportLoading = createSelector(
  [getLoading, getData],
  (loading, data) => loading && !data,
);

export const getLastUpdated = createSelector(
  getData,
  path(['meta', 'lastUpdated']),
);

export const getPatientId = createSelector(
  getData,
  pipe(
    path(['entry', '0', 'resource', 'subject', 'reference']),
    patientIdString => {
      if (!patientIdString) {
        return '';
      }

      return patientIdString.split('/')[1];
    },
  ),
);

export const getTachyReportLoadingById = id =>
  createSelector(
    [getTachyReportLoading, getPatientId],
    (loading, patientId) => {
      return loading && patientId !== id;
    },
  );

const newReportState = prop('newReport');

export const getReportPdfFile = createSelector(
  newReportState,
  prop('pdfBase64'),
);

export const getCreatedTachyReportData = patientId =>
  createSelector(
    getReportPdfFile,
    getResearchersAndDoctors(patientId),
    (pdfBase64, author) => {
      return {
        resourceType: 'DocumentReference',
        status: CURRENT,
        indexed: moment().toISOString(),
        type: {
          coding: [
            {
              code: 'tachy',
              display: 'Detailed tachy report',
            },
          ],
        },
        subject: {
          reference: `Patient/${patientId}`,
        },
        author,
        content: [
          {
            attachment: {
              contentType: 'pdf',
              data: pdfBase64.replace(/^data:(.*;base64,)?/, ''),
            },
          },
        ],
      };
    },
  );
